import Text from '@/components/Text';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';

export const ValueExpressionExamples = () => {
    const [isExpanded, setIsExpanded] = useState(true);
    return (
        <>
            <button 
                onClick={() => setIsExpanded(current => !current)}
                type='button'
                className='flex items-center mt-6'
            >
                <Text.Body className='inline-flex items-center gap-3 text-base font-medium'>
                    <span>Examples</span>
                    <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
                </Text.Body>
            </button>

            <AnimatePresence>
                {isExpanded &&
                    <motion.div 
                        className='relative overflow-hidden -z-10'
                        initial={{ height: 0 }}
                        animate={{ height: 'auto' }}
                        exit={{ height: 0 }}
                        transition={{ ease: 'easeInOut' }}
                    >
                        <div
                            style={{
                                fontFamily: 'Menlo, Monaco, "Courier New", monospace',
                                fontWeight: 'normal',
                                fontSize: '12px',
                                fontFeatureSettings: '"liga" 0, "calt" 0',
                                fontVariationSettings: 'normal',
                                lineHeight: '18px',
                                letterSpacing: '0px'
                            }}
                            className='overflow-hidden divide-x divide-outlinePrimary flex-col space-x-4 flex mt-1 w-full !outline-none monaco-editor bg-componentBackgroundSecondary'
                        >
                            <div className='p-3 overflow-hidden'>
                                <span className=''>
                                    <span className='mtk7'>// Creating URLs</span>
                                </span>
                                <br />
                                <div>
                                    <span className='mtk7 text-formatExpressionLiteral'>https://example.com?ticketId=</span>
                                    <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                        {'{{ '}
                                    </span>
                                    <span className='mtk1'>$</span>
                                    <span className='mtk9 bracket-highlighting-2'>[</span>
                                    <span className='mtk5'>'id'</span>
                                    <span className='mtk9 bracket-highlighting-2'>]</span>
                                    <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                        {' }}'}
                                    </span>
                                </div>

                                <br />

                                <span className=''>
                                    <span className='mtk7'>// Mapping values to states or booleans</span>
                                </span>
                                <br />
                                <span className=''>
                                    <span>
                                        <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                            {'{{ '}
                                        </span>
                                        <span className='mtk1'>$</span>
                                        <span className='mtk9 bracket-highlighting-2'>[</span>
                                        <span className='mtk5'>'value'</span>
                                        <span className='mtk9 bracket-highlighting-2'>]</span>
                                        <span className='mtk9'> / </span>
                                        <span className='mtk6'> 100 </span>
                                        <span className='mtk9'> ? </span>
                                        <span className='mtk5'> 'success' </span>
                                        <span className='mtk9'> : </span>
                                        <span className='mtk5'> 'error' </span>
                                        <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                            {' }}'}
                                        </span>
                                    </span>
                                </span>
                                <br />
                                <span className=''>
                                    <span>
                                        <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                            {'{{ '}
                                        </span>
                                        <span className='mtk1'>$</span>
                                        <span className='mtk9 bracket-highlighting-2'>[</span>
                                        <span className='mtk5'>'log'</span>
                                        <span className='mtk9 bracket-highlighting-2'>]</span>
                                        <span className='mtk9'>.includes</span>
                                        <span className='mtk6'>{'('}</span>
                                        <span className='mtk5'>'ERROR'</span>
                                        <span className='mtk6'>{')'}</span>
                                        <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                            {' }}'}
                                        </span>
                                    </span>
                                </span>

                                <br />
                                <br />

                                <span className=''>
                                    <span className='mtk7'>// Math operations</span>
                                </span>
                                <br />
                                <div>
                                    <span className='mtk9 text-formatExpressionTemplateDelimiter bracket-highlighting-1'>
                                        {'{{ '}
                                    </span>
                                    <span className='mtk1'>$</span>
                                    <span className='mtk9 bracket-highlighting-2'>[</span>
                                    <span className='mtk5'>'columnName'</span>
                                    <span className='mtk9 bracket-highlighting-2'>]</span>
                                    <span className='mtk9'> /</span>
                                    <span className='mtk6'> 1000</span>
                                    <span className='mtk9 bracket-highlighting-1 text-formatExpressionTemplateDelimiter'>
                                        {' }}'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                }
            </AnimatePresence>
        </>
    );
};
